import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { NavLink } from "@/components/NavLink";
import { ArrowRight } from "lucide-react";

interface HubItem {
  title: string;
  description: string;
  href: string;
}

interface HubPageGridProps {
  items: HubItem[];
}

export const HubPageGrid = ({ items }: HubPageGridProps) => {
  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
      {items.map((item, index) => (
        <NavLink key={index} to={item.href} className="group">
          <Card className="h-full transition-all hover:border-primary hover:shadow-md">
            <CardHeader>
              <CardTitle className="text-lg group-hover:text-primary transition-colors">
                {item.title}
              </CardTitle>
              <CardDescription>{item.description}</CardDescription>
            </CardHeader>
            <CardContent>
              <span className="text-primary flex items-center gap-2 text-sm font-medium">
                Read More
                <ArrowRight className="h-4 w-4 group-hover:translate-x-1 transition-transform" />
              </span>
            </CardContent>
          </Card>
        </NavLink>
      ))}
    </div>
  );
};
